export default function WhatIs() {
  return (
    <section id="about" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[900px] mx-auto px-6 md:px-10 text-center">
        <span className="text-xs font-semibold uppercase tracking-[0.2em] text-secondary-600">The Ultimate Resource</span>
        <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mt-4">What Is <span className="italic font-normal text-accent-500">Superbuy Spreadsheet</span>?</h2>
        <p className="mt-6 text-foreground-600 text-sm md:text-base leading-relaxed max-w-2xl mx-auto">
          Superbuy Spreadsheet is a structured data management solution designed to help users organize product information, track purchasing details, compare options, and improve their shopping efficiency. Whether you are a casual shopper looking to keep track of your favorite finds or a power buyer managing hundreds of items across multiple stores, the Superbuy Spreadsheet approach gives you the clarity and control you need. By centralizing product data in a well-organized spreadsheet format, you eliminate guesswork, reduce impulse purchases, and make decisions backed by real comparison data rather than fleeting emotions.
        </p>
        <div className="mt-10 overflow-x-auto">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="border-b border-background-300/60">
                <th className="py-3 px-4 text-sm font-semibold text-foreground-800">Feature</th>
                <th className="py-3 px-4 text-sm font-semibold text-foreground-800">Superbuy Spreadsheet</th>
                <th className="py-3 px-4 text-sm font-semibold text-foreground-800">Traditional Notes</th>
                <th className="py-3 px-4 text-sm font-semibold text-foreground-800">Manual Tracking</th>
              </tr>
            </thead>
            <tbody className="text-sm text-foreground-600">
              <tr className="border-b border-background-200/50">
                <td className="py-3 px-4 font-medium text-foreground-800">Organization</td>
                <td className="py-3 px-4"><span className="inline-flex items-center gap-1 text-accent-500"><span className="w-4 h-4 flex items-center justify-center"><i className="ri-check-line"></i></span>Excellent</span></td>
                <td className="py-3 px-4">Limited</td>
                <td className="py-3 px-4">Poor</td>
              </tr>
              <tr className="border-b border-background-200/50">
                <td className="py-3 px-4 font-medium text-foreground-800">Search</td>
                <td className="py-3 px-4"><span className="inline-flex items-center gap-1 text-accent-500"><span className="w-4 h-4 flex items-center justify-center"><i className="ri-check-line"></i></span>Instant</span></td>
                <td className="py-3 px-4">Slow</td>
                <td className="py-3 px-4">None</td>
              </tr>
              <tr className="border-b border-background-200/50">
                <td className="py-3 px-4 font-medium text-foreground-800">Data Management</td>
                <td className="py-3 px-4"><span className="inline-flex items-center gap-1 text-accent-500"><span className="w-4 h-4 flex items-center justify-center"><i className="ri-check-line"></i></span>Structured</span></td>
                <td className="py-3 px-4">Unstructured</td>
                <td className="py-3 px-4">None</td>
              </tr>
              <tr className="border-b border-background-200/50">
                <td className="py-3 px-4 font-medium text-foreground-800">Price Tracking</td>
                <td className="py-3 px-4"><span className="inline-flex items-center gap-1 text-accent-500"><span className="w-4 h-4 flex items-center justify-center"><i className="ri-check-line"></i></span>Automated</span></td>
                <td className="py-3 px-4">Manual</td>
                <td className="py-3 px-4">None</td>
              </tr>
              <tr>
                <td className="py-3 px-4 font-medium text-foreground-800">Efficiency</td>
                <td className="py-3 px-4"><span className="inline-flex items-center gap-1 text-accent-500"><span className="w-4 h-4 flex items-center justify-center"><i className="ri-check-line"></i></span>High</span></td>
                <td className="py-3 px-4">Medium</td>
                <td className="py-3 px-4">Low</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}